import React from "react"
import { Link, Route, Switch } from "react-router-dom"
import MediaPlayer from "../footer_player_bar/media_player"
import PlaylistIndexContainer from "../playlists/playlist_index_container"
import PlaylistShowContainer from "../show_pages/playlist_show_container"
import SideNavBar from "./side_nav_bar"
import FooterPlayerBar from "../footer_player_bar/footer_player_bar"

class MusicPage extends React.Component {
    render() {
        return null
    }
}

export default MusicPage
